import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";

export const onRedirectBacklinksDuration = (durationParam: string): transitionHookFn => {
    return (transition) => {
        const params = transition.params();

        if (params.duration !== durationParam) {
            return {
                params: {
                    ...params,
                    duration: durationParam,
                },
            };
        }

        return void 0;
    };
};
